import * as React from 'react';

/**
 * The portal's own locale, published by `PortalIntlBoundary` over the subtree it
 * wraps, as a hyphenated BCP-47 tag with the region kept.
 *
 * `undefined` means "not inside a portal-scoped boundary". That default is what
 * keeps non-portal surfaces — CSM request details, the customisation editors,
 * embedded pages — on the user's account locale without needing a per-consumer
 * opt-out list.
 */
const PortalLocaleContext = React.createContext<string | undefined>(undefined);

export const PortalLocaleProvider = PortalLocaleContext.Provider;

export const usePortalLocale = (): string | undefined => React.useContext(PortalLocaleContext);
